module.exports = __webpack_public_path__ + "img/lotd_3.6ccdbbda.png";